import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { EditRounded } from "@mui/icons-material";
import { AdminToggle, DataTableColumn } from "../../../components/ui";
import { ActiveResponse } from "../../../services/decisionFlow";

type Options = {
    onToggle: (active: ActiveResponse) => void;
    onEdit: (active: ActiveResponse) => void;
};

/** Colunas da tabela de classes de ativos (Nome / Status / Ações). */
export function buildActivesColumns({ onToggle, onEdit }: Options): DataTableColumn<ActiveResponse>[] {
    return [
        {
            key: "name",
            header: "Nome",
            width: "2fr",
            render: (row) => <Typography sx={{ fontSize: "14px", fontWeight: 500, color: "text.primary" }}>{row.name}</Typography>,
        },
        {
            key: "enabled",
            header: "Status",
            width: "1fr",
            render: (row) => (
                <AdminToggle checked={row.enabled ?? false} onChange={() => onToggle(row)} label={row.enabled ? "Habilitado" : "Desabilitado"} />
            ),
        },
        {
            key: "actions",
            header: "Ações",
            width: "100px",
            align: "right",
            render: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <Tooltip title="Editar" placement="top">
                        <IconButton
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit(row);
                            }}
                            aria-label="Editar"
                            sx={{ borderRadius: "9px" }}
                        >
                            <EditRounded sx={{ fontSize: 16 }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            ),
        },
    ];
}
